const fonts = {
    stacks: {
        primary: 'Vodafone, Arial, sans-serif',
        secondary: 'Vodafone, Arial, sans-serif',
    },
    foundations: {
        mobile: {
            body: 'font-size: 1rem; line-height: 1.5;',
            h1: 'font-size: 2rem; line-height: 1.25;',
            h2: 'font-size: 1.5rem; line-height: 1.25;',
            h3: 'font-size: 1.25rem; line-height: 1.25;',
            h4: 'font-size: 1rem; line-height: 1.25;',
            h5: 'font-size: 0.875rem; line-height: 1.25;',
            h6: 'font-size: 0.875rem; line-height: 1.25;',
        },
        desktop: {
            body: 'font-size: 1rem; line-height: 1.5;',
            h1: 'font-size: 2.5rem; line-height: 1.25;',
            h2: 'font-size: 1.75rem; line-height: 1.25;',
            h3: 'font-size: 1.25rem; line-height: 1.25;',
            h4: 'font-size: 1.125rem; line-height: 1.25;',
            h5: 'font-size: 0.875rem; line-height: 1.25;',
            h6: 'font-size: 0.875rem; line-height: 1.25;',
        },
    },
    weights: {
        ultralight: 100,
        light: 200,
        regular: 400,
        bold: 600,
    },
};
export default fonts;
//# sourceMappingURL=fonts.js.map